import type { AnchorHref } from './types'
import { useOnScreen } from '@/scopes/common/components/hooks/useOnScreen'
import { type ReactNode, useRef } from 'react'
import styles from './AnchorTarget.module.css'

const ANCHOR_SELECTION_CLASS = 'anchorTarget'

interface AnchorTargetProps {
  anchorHref: AnchorHref
  children: ReactNode
  onAnchorIntersect: ({ anchorHref, isIntersecting, anchorTopPositions }: { anchorHref: AnchorHref, isIntersecting: boolean, anchorTopPositions: Record<string, number> }) => void
}

export default function AnchorTarget({ anchorHref, children, onAnchorIntersect }: AnchorTargetProps) {
  const ref = useRef<HTMLDivElement>(null)
  useOnScreen(ref, {
    threshold: [0, 0.05, 0.1, 0.2, 0.5, 0.8, 0.9, 0.95, 1],
    onIntersect: ({ entry }) => {
      onAnchorIntersect({
        anchorHref,
        isIntersecting: entry.isIntersecting,
        anchorTopPositions: getAnchorsTopPositions(),
      })
    },
  })

  return (
    <div ref={ref} id={anchorHref} className={`${ANCHOR_SELECTION_CLASS} ${styles.target}`}>
      {children}
    </div>
  )
}

function getAnchorsTopPositions(): Record<string, number> {
  return Object.fromEntries(
    Array.from(document.querySelectorAll<HTMLDivElement>(`.${ANCHOR_SELECTION_CLASS}`)).map(anchorElement => [
      anchorElement.id,
      anchorElement.getBoundingClientRect().top,
    ]),
  )
}
